import Cookies from 'js-cookie'

type Props = {
  id: number | string
  closeDateTime?: Date | string
  maxCloseCount?: number
}

export const DEFAULT_EXPIRE_DAYS = 180
const DAY = 24 * 60 * 60
export const NOTICE_KEY_SUFFIX = '-notice-closed-count'

const noticeCookie = ({ id, closeDateTime, maxCloseCount = 1 }: Props) => {
  const noticeKey = `${id}${NOTICE_KEY_SUFFIX}`
  const closeCount = Number(Cookies.get(noticeKey) ?? 0)
  const shouldShow = closeCount < maxCloseCount

  const closeNotice = () => {
    Cookies.set(noticeKey, (closeCount + 1).toString(), {
      path: '/',
      expires: closeDateTime ? new Date(closeDateTime) : DEFAULT_EXPIRE_DAYS * DAY,
    })
  }

  return {
    shouldShow,
    closeNotice,
  }
}

export default noticeCookie
